import { render, staticRenderFns } from "./ClickableIdCell.vue?vue&type=template&id=ba743d88&"
import script from "./ClickableIdCell.vue?vue&type=script&lang=babel&"
export * from "./ClickableIdCell.vue?vue&type=script&lang=babel&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports